import { HttpEvent, HttpHandler, HttpInterceptor, HttpRequest } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { BrandingService } from '../services/branding.service';

@Injectable()
export class BrandingInterceptor implements HttpInterceptor {
  constructor(private readonly brandingService: BrandingService) {}

  intercept(req: HttpRequest<any>, next: HttpHandler): Observable<HttpEvent<any>> {
    if (this.brandingService.brandingIdentifier) {
      req = req.clone({
        setHeaders: {
          'X-MdS-Branding': this.brandingService.brandingIdentifier,
        },
      });
    }

    return next.handle(req);
  }
}
